import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Link } from 'react-router-dom';
import logo from '../tempus-logo.png'
import { Navbar, NavbarToggler, Collapse, NavItem, Nav, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import moment from 'moment';
import pkg from '../../package.json';
const { version } = pkg;

export enum NavbarRoute {
  HOME = '/', REPORTS = '/reports', PROJECTS = '/projects'
}

function NavigationBar() {
  const { user, isAuthenticated, logout, loginWithRedirect } = useAuth0();
  const [active, setActive] = useState(window.location.pathname as NavbarRoute);
  const [toggled, setToggled] = useState(false);

  return (
    <Navbar expand="md" className='shadow navbar-light'>
      <a href='/' className='navbar-logo me-3'><img src={logo} className="rounded-circle img-fluid" alt='logo' /></a>
      <span className='text-muted me-2' style={{ fontSize: '0.7rem' }}>v{version}</span>
      <NavbarToggler onClick={() => setToggled(!toggled)} className="mr-2" />
      <Collapse isOpen={toggled} navbar>
        <Nav className="me-auto" navbar>
          <NavItem>
            <Link to='/' className={`nav-link ${active === NavbarRoute.HOME ? 'active' : ''}`} onClick={() => setActive(NavbarRoute.HOME)}>Home</Link>
          </NavItem>
          {
            isAuthenticated ? <>
              <NavItem>
                <Link to='/projects' className={`nav-link ${active === NavbarRoute.PROJECTS ? 'active' : ''}`} onClick={() => setActive(NavbarRoute.PROJECTS)}>Projects</Link>
              </NavItem>
              <NavItem>
                <Link to='/reports' className={`nav-link ${active === NavbarRoute.REPORTS ? 'active' : ''}`} onClick={() => setActive(NavbarRoute.REPORTS)}>Reports</Link>
              </NavItem>
            </> : null
          }
        </Nav>
        <div className='d-flex navbar-nav'>
          {
            isAuthenticated ?
              <UncontrolledDropdown>
                <DropdownToggle caret nav>
                  <img src={user && user?.picture} className="rounded-circle img-fluid navbar-logo me-3" style={{ width: '32px' }} alt='Pic' />{user?.name}
                </DropdownToggle>
                <DropdownMenu end className='p-0'>
                  <DropdownItem header className='alert-warning'>
                    Logged in since <b>{moment(user?.updated_at).format('lll')}</b>
                  </DropdownItem>
                  <DropdownItem onClick={() => { logout({ logoutParams: { returnTo: window.location.origin } }); }}>
                    Logout
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              : <button className='link-button nav-link' onClick={() => loginWithRedirect()}>Login</button>
          }
        </div>
      </Collapse>
    </Navbar>
  );
}

export default NavigationBar;
